module.exports = __webpack_public_path__ + "img/trashRojo.300025a2.svg";